import apiService from './api.service';
import {
  SignUpRequest,
  SignInRequest,
  VerifyPhoneRequest,
  UpdateAccountRequest,
  ResetPasswordRequest,
  ResetPasswordConfirmRequest,
  AuthResponse,
  User,
} from '../types/auth.types';

class AuthService {
  async signUp(data: SignUpRequest): Promise<{ message: string; success: boolean }> {
    const response = await apiService.client.post('/auth/register', {
      email: data.email,
      phone_number: data.phoneNumber,
      password: data.password,
      product_line: data.productLine || 'full'
    });
    return response.data;
  }

  async signIn(data: SignInRequest): Promise<{ access_token: string; refresh_token: string; token_type: string }> {
    const response = await apiService.client.post('/auth/login', data);
    if (response.data.access_token) {
      localStorage.setItem('accessToken', response.data.access_token);
      if (response.data.refresh_token) {
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }
    }
    return response.data;
  }

  async verifyEmail(token: string): Promise<{ access_token: string; refresh_token: string; token_type: string }> {
    const response = await apiService.client.post('/auth/verify-email', { code: token });
    if (response.data.access_token) {
      localStorage.setItem('accessToken', response.data.access_token);
      if (response.data.refresh_token) {
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }
    }
    return response.data;
  }

  async verifyPhone(data: VerifyPhoneRequest): Promise<{ access_token: string; refresh_token: string; token_type: string }> {
    const response = await apiService.client.post('/auth/verify-phone', {
      phone_number: data.phoneNumber,
      code: data.code
    });
    if (response.data.access_token) {
      localStorage.setItem('accessToken', response.data.access_token);
      if (response.data.refresh_token) {
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }
    }
    return response.data;
  }

  async updateAccount(data: UpdateAccountRequest): Promise<User> {
    const updateData: any = {};
    if (data.email) updateData.email = data.email;
    if (data.phoneNumber) updateData.phone_number = data.phoneNumber;
    if (data.password) updateData.password = data.password;

    const response = await apiService.client.put<User>('/users/me', updateData);
    return response.data;
  }

  async resetPassword(data: ResetPasswordRequest): Promise<{ success: boolean; message: string }> {
    const response = await apiService.client.post('/auth/password-reset', data);
    return response.data;
  }

  async confirmResetPassword(data: ResetPasswordConfirmRequest): Promise<{ success: boolean; message: string }> {
    const response = await apiService.client.post('/auth/password-reset/confirm', {
      token: data.token,
      new_password: data.newPassword
    });
    return response.data;
  }

  async getCurrentUser(): Promise<User> {
    const response = await apiService.client.get<User>('/users/me');
    return response.data;
  }

  async resendVerification(email: string): Promise<{ success: boolean; message: string }> {
    const response = await apiService.client.post('/auth/resend-verification', { email });
    return response.data;
  }

  signOut() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    window.location.href = '/signin';
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('accessToken');
  }
}

export default new AuthService();